import { render, staticRenderFns } from "./invoice-attach-bank-slip.vue?vue&type=template&id=013589a0&scoped=true"
import script from "./invoice-attach-bank-slip.vue?vue&type=script&lang=js"
export * from "./invoice-attach-bank-slip.vue?vue&type=script&lang=js"
import style0 from "./invoice-attach-bank-slip.vue?vue&type=style&index=0&id=013589a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013589a0",
  null
  
)

export default component.exports